import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Cms } from '@impact/data';
import { Observable } from 'rxjs';
import { chevronDownIcon } from '../../../icons';
import { NavigationService } from '../navigation.service';

@Component({
    selector: 'app-side-navigation',
    template: `
        <nav *ngIf="currentSubtree$ | async as currentSubtree">
            <h5>
                <a
                    class="side-navigation-link"
                    [innerText]="currentSubtree.name"
                    [routerLink]="currentSubtree.url"
                ></a>
            </h5>
            <ul class="side-navigation-list">
                <li *ngFor="let subLevel of currentSubtree.children">
                    <app-expansion-panel
                        class="side-navigation-sub-level"
                        *ngIf="subLevel.includeInNavigation"
                        [expanded]="subLevel | isExpanded: router.url"
                    >
                        <a
                            class="side-navigation-link side-navigation-sub-level__link"
                            expansion-title
                            [class.side-navigation-link--active]="subLevel | isActive: router.url"
                            [innerText]="subLevel.name"
                            [routerLink]="subLevel.url"
                        ></a>

                        <ng-container
                            expansion-icon
                            *ngIf="subLevel.children?.length"
                        >
                            ${chevronDownIcon}
                        </ng-container>

                        <ul class="side-navigation-list">
                            <ng-container
                                *ngFor="let subSubLevel of subLevel.children"
                            >
                                <li *ngIf="subSubLevel.includeInNavigation">
                                    <a
                                        class="side-navigation-link side-navigation-sub-sub-level"
                                        [class.side-navigation-link--active]="subSubLevel | isActive: router.url"
                                        [innerText]="subSubLevel.name"
                                        [routerLink]="subSubLevel.url"
                                    ></a>
                                </li>
                            </ng-container>
                        </ul>
                    </app-expansion-panel>
                </li>
            </ul>
        </nav>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavigationComponent {
    currentSubtree$ = this.navigationService.getCurrentSubTree();

    constructor(
        public readonly router: Router,
        private readonly navigationService: NavigationService
    ) {}
}
